import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  GrantTerm,
  GrantedArea,
  NameLowercase,
  Note,
  PersonalId,
  Regency,
  Sex,
  Team,
} from "./_fields";

type SecurityCardsToExternalEntitiesProvideTemplate = {
  name: string;
  sex: string;
  personalId: number;
  regency: string;
  unit: string;
  grantTerm: string;
  grantedArea: string;
  note: string;
};

export const securityCardsToExternalEntitiesProvideTemplate: TemplatesValue<SecurityCardsToExternalEntitiesProvideTemplate> =
  {
    fileName: "DanhSachNhanVienCapThe",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      NameLowercase,
      Sex,
      PersonalId,
      Regency,
      {
        ...Team,
        header: "Đơn vị"
      },
      GrantTerm,
      {
        ...GrantedArea,
        header: "Khu vực được cấp",
      },
      Note,
    ],
    fields: ["name", "sex", "personalId", "regency", "unit", "grantTerm", "grantedArea", "note"],
  };
